import { render, staticRenderFns } from "./BudgetObjectDetails.vue?vue&type=template&id=c7ba9dd6&scoped=true&"
import script from "./BudgetObjectDetails.vue?vue&type=script&lang=js&"
export * from "./BudgetObjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ba9dd6",
  null
  
)

export default component.exports